import React, { useEffect, useState } from "react";
import "../aseets/css/Offerings.css";

const services = [
    {
        title: "Performance Marketing",
        color: "#3b82f6",
        icon: "⚡",
        bgIcon: "⚡",
        desc: "Data-driven campaigns focused on ROI, conversions, and scalable growth."
    },
    {
        title: "Search Engine Optimisation",
        color: "#ec4899",
        icon: "🔍",
        bgIcon: "🔍",
        desc: "Improve visibility, rankings, and organic traffic with proven SEO strategies."
    },
    {
        title: "Social Media Marketing",
        color: "#facc15",
        icon: "📱",
        bgIcon: "📱",
        desc: "Build brand awareness and engagement across all social platforms."
    },
    {
        title: "Google Ads Marketing",
        color: "#fb923c",
        icon: "📢",
        bgIcon: "📢",
        desc: "High-performing paid campaigns optimized for leads and sales."
    },
    {
        title: "Website Design",
        color: "#2dd4bf",
        icon: "💻",
        bgIcon: "💻",
        desc: "Modern, conversion-focused designs tailored to your brand."
    },
    {
        title: "Website Design & Development",
        color: "#fb7185",
        icon: "🛠️",
        bgIcon: "🛠️",
        desc: "End-to-end web solutions built for speed, UX, and scalability."
    },
    {
        title: "Online Reputation Management",
        color: "#c084fc",
        icon: "⭐",
        bgIcon: "⭐",
        desc: "Protect and enhance your brand’s online image and trust."
    },
    {
        title: "Influencer Marketing",
        color: "#6366f1",
        icon: "🎥",
        bgIcon: "🎥",
        desc: "Connect with the right influencers to amplify your message."
    },
    {
        title: "Branding",
        color: "#3b82f6",
        icon: "🎯",
        bgIcon: "🎯",
        desc: "Create a strong, consistent identity that customers remember."
    }
];

export default function Offerings() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const el = document.getElementById("offerings");
            if (!el) return;
            const rect = el.getBoundingClientRect();
            if (rect.top < window.innerHeight * 0.7) {
                setVisible(true);
            }
        };

        window.addEventListener("scroll", onScroll);
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <section id="offerings" className="of-section">
            <div className="of-header">
                <span className="of-label">OUR SERVICES</span>
                <h2 className="of-title">
                    We Are  <br />
                    <span>The Experts Of</span>
                </h2>
            </div>

            <div className={`of-grid ${visible ? "show" : ""}`}>
                {services.map((s, i) => (
                    <div
                        key={i}
                        className="of-card"
                        style={{
                            "--accent": s.color,
                            "--bg-icon": `"${s.bgIcon}"`,
                            "--i": i
                        }}
                    >



                        <div className="of-card-inner">
                            <div className="of-card-front">
                                {/* FLOATING BG ICONS */}
                                <div className="of-bg-icons">
                                    <span />
                                    <span />
                                </div>
                                <div className="of-icon">{s.icon}</div>
                                <h3>{s.title}</h3>
                            </div>

                            <div className="of-card-back">
                                <h4>{s.title}</h4>
                                <p>{s.desc}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
